import { create } from 'zustand'
import { devtools, persist, createJSONStorage } from 'zustand/middleware'
import type { HotelAvailabilityParams } from '~/hooks/type'
import type { RoomAvailabilitySearch, RoomPriceGroup, MappedPrices } from '~/types/hotel'

interface HotelAvailabilityState {
  availability: RoomAvailabilitySearch[]
  groupedPrices: RoomPriceGroup[]
  mappedPrices: MappedPrices
  searchParams: HotelAvailabilityParams | null
  isLoading: boolean
  isError: boolean | null
  setAvailability: (data: RoomAvailabilitySearch[]) => void
  setGroupedPrices: (data: RoomPriceGroup[]) => void
  setSearchParams: (
    params:
      | HotelAvailabilityParams
      | ((prev: HotelAvailabilityParams | null) => HotelAvailabilityParams | null)
  ) => void
  setMappedPrices: (data: MappedPrices) => void
  setLoading: (loading: boolean) => void
  setError: (error: boolean) => void
  reset: () => void
}

export const useHotelAvailabilitySearchStore = create<HotelAvailabilityState>()(
  devtools(
    persist(
      (set) => ({
        availability: [],
        groupedPrices: [],
        mappedPrices: {},
        searchParams: null,
        isLoading: false,
        isError: null,

        setAvailability: (data) => set({ availability: data }),
        setGroupedPrices: (data) => set({ groupedPrices: data }),
        setMappedPrices: (data) => set({ mappedPrices: data }),
        setSearchParams: (params) =>
          set((state) => ({
            searchParams: typeof params === 'function' ? params(state.searchParams) : params,
          })),
        setLoading: (loading) => set({ isLoading: loading }),
        setError: (error) => set({ isError: error }),
        reset: () =>
          set({
            availability: [],
            groupedPrices: [],
            mappedPrices: {},
            searchParams: null,
            isLoading: false,
            isError: null,
          }),
      }),
      {
        name: 'hotel-availability-search-storage',
        storage: createJSONStorage(() => sessionStorage),
        partialize: (state) => ({
          mappedPrices: state.mappedPrices,
        }),
      }
    )
  )
)
